// extracted by mini-css-extract-plugin
export var equalColumn = "_hd-0";